import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";

import { getCities, normalizeLocationList } from "~/services/http/locations";
import {
  locationSelectMenuProps,
  locationSelectSx,
} from "components/Inputs/locationSelectProps";

export default function CityMultiSelect(props) {
  const { name, value, updateValues, disabled = false } = props;
  const { t } = useTranslation();
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getCities({
      params: {
        ordering: "name",
        limit: 500,
      },
    }).then((response) => {
      setCities(
        normalizeLocationList(response).map((city) => ({
          id: city.id,
          name: city.name,
        })),
      );
      setLoading(false);
    });
  }, []);

  const selectedIds = (value ?? []).map((item) => item.value);

  const handleChange = ({ target }) => {
    const ids = target.value;
    const newValue = ids.map((id) => {
      const city = cities.find((item) => item.id === id);
      return { value: id, label: city?.name ?? String(id) };
    });
    updateValues({ [name]: newValue });
  };

  return (
    <TextField
      id="company_secondary_cities"
      select
      label={t("Valitse kaupungit")}
      value={selectedIds}
      name={name}
      onChange={handleChange}
      margin="dense"
      variant="outlined"
      fullWidth
      disabled={disabled || loading}
      placeholder={loading ? t("Ladataan…") : undefined}
      sx={locationSelectSx}
      slotProps={{
        select: {
          multiple: true,
          MenuProps: locationSelectMenuProps,
          renderValue: (selected) =>
            selected
              .map((id) => cities.find((city) => city.id === id)?.name)
              .filter(Boolean)
              .join(", "),
        },
      }}
    >
      {cities.map((city) => (
        <MenuItem key={city.id} value={city.id}>
          <Checkbox
            checked={selectedIds.indexOf(city.id) > -1}
            size="small"
            sx={{ py: 0, mr: 1 }}
          />
          {city.name}
        </MenuItem>
      ))}
    </TextField>
  );
}
